import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import Button from "../Component/Button";

import GreyLine from "../Component/GreyLine";
import {
  FormPageAction,
  restCouponDetailAction,
  setStartDateParam,
  userDetailAction,
} from "../Component/Redux/Feature/UrlSlice";
import axios from "axios";
import {
  appAction,
  checkBoxAction,
  contactAction,
  emailAction,
  tokenAction,
} from "../Component/Redux/Feature/EmailSlice";
import DateInput from "../Component/DateInput";
import { apiUrl, appname } from "../Utils/constants";
// import { publicEncrypt, constants } from "crypto";
// import { constants } from "buffer";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import CountdownTimer, { useCountdown } from "./UseCountdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '@fortawesome/fontawesome-free/css/all.min.css';
// Equality helpers to ignore referential churn in reducers
const areSessionsArraysEqual = (a, b) => {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b)) return a === b; // both null/undefined
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const x = a[i], y = b[i];
    // compare a minimal stable subset; adjust fields if needed
    if (
      x?.sessionid !== y?.sessionid ||
      x?.sumcost !== y?.sumcost ||
      x?.daystime !== y?.daystime ||
      x?.name !== y?.name
    ) return false;
  }
  return true;
};

// Coerce undefined/null to '' to keep comparisons stable for string fields
const toStableString = (v) => (v === undefined || v === null ? "" : v);

// Optional logging comparator for primitives; returns true if equal
const primitiveEqWithLog = (label) => (next, prev) => {
  const a = toStableString(prev);
  const b = toStableString(next);
  const same = Object.is(a, b);
  if (!same) {
    console.log(`[HomeContentNew] selector changed -> ${label}:`, { prev: a, next: b });
  }
  return same;
};

const HomeContentNew = (props) => {
  const [selectedDateParam, setSelectedDateParam] = useState("");
  const [selectedDateEnable, setSelectedDateEnable] = useState(false);
  const [token, setToken] = useState(null);
  
  const [onlyForTrial, setOnlyForTrial] = useState(false);
  const [showTrialPackages, setShowTrialPackages] = useState(true);
//   const selectedCategory = useSelector((state) => state.Categories?.selectedCategory);
// console.log(selectedCategory, "selectedCategory in HomeContentNew");
  const [copiedToast, setCopiedToast] = useState(false);

  // const [dateDisabled, setDateDisabled] = useState(false);

  const [userId, setUserId] = useState();
  const [sessionCoupons, setSessionCoupons] = useState({});

 
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(window.location.search);
  const emailParam = queryParams.get("email");
  const appParam = queryParams.get("app");

  const contactParams = queryParams.get("contact");
  const storedQueryValues = useSelector(
    (state) => ({
      emailStored: state.emailData?.emailStored,
      contactStored: state.emailData?.contactStored,
      appStatusStored: state.emailData?.appStatus,
      userDetailsEmail: state.UrlData?.userDetails?.email,
      userDetailsPhone: state.UrlData?.userDetails?.phone,
    }),
    shallowEqual
  );
  const effectiveEmail =
    emailParam || storedQueryValues.emailStored || storedQueryValues.userDetailsEmail;
  const effectiveContact =
    contactParams || storedQueryValues.contactStored || storedQueryValues.userDetailsPhone;
  const hasStoredAppStatus =
    storedQueryValues.appStatusStored !== null &&
    storedQueryValues.appStatusStored !== undefined;
  const effectiveAppStatus =
    appParam !== null
      ? appParam === "true"
      : storedQueryValues.appStatusStored === "true" ||
        storedQueryValues.appStatusStored === true;

  useEffect(() => {
    if (effectiveEmail) {
      dispatch(emailAction(effectiveEmail));
    }
    if (effectiveContact) {
      dispatch(contactAction(effectiveContact));
    }
    if (appParam !== null || hasStoredAppStatus) {
      dispatch(appAction(effectiveAppStatus));
    }
    if (effectiveEmail && effectiveContact) {
      dispatch(
        FormPageAction({
          email: effectiveEmail,
          phone: effectiveContact,
        })
      );
    }
  }, [
    appParam,
    dispatch,
    effectiveAppStatus,
    effectiveContact,
    effectiveEmail,
    hasStoredAppStatus,
  ]);
  console.log("effectiveEmail => ", effectiveEmail);


  useEffect(() => {

    dispatch(restCouponDetailAction());

    const queryParams = new URLSearchParams(window.location.search);
    const startDateParam = queryParams.get("startdate");


    if (startDateParam) {
     
      dispatch(setStartDateParam(startDateParam))
      dispatch(checkBoxAction(1));
      setSelectDate(startDateParam)
     
      setSelectedDateParam(startDateParam);

      console.log("start date param => ", queryParams.get("startdate"));
      setSelectedDateEnable(true);
      // setDateDisabled(true);
      // setStartDateAvailable(true)
    } else {
      setSelectedDateParam("");
      // setDateDisabled(false);
      // setStartDateAvailable(false)
    }
  }, []);

  // if (queryParams.get("email")) dispatch(emailAction(emailParam));
  // if (queryParams.get("contact")) dispatch(contactAction(contactParams));
  // if (queryParams.get("app")) dispatch(appAction(appStatus == "true"));

  // if (queryParams.get("email") && queryParams.get("contact"))
  //   dispatch(
  //     FormPageAction({
  //       email: emailParam,
  //       phone: contactParams,
  //     })
  //   );

    useEffect(() => {
      setOnlyForTrial(false);
      setShowTrialPackages(!effectiveEmail || !props.catid);
      if (!effectiveEmail || !props.catid) return;

      let cancelled = false;

      const fetchToken = async () => {
        try {
          const response = await axios.post(`${apiUrl}/checkUserEmail`, { email: effectiveEmail });
          if (cancelled) return;

          const fetchedUserId = response.data?.data?.uid;
          setUserId(fetchedUserId);
          if (!fetchedUserId) return;
    
          const publicKeyPem = `-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9KMZq1nFwAIUBIfe02KwG99Zn
    I5bZZ3PF3xA0Y6/EphSIb9OC04RCxY5Hu7oFw2oewy5wRiI4kUEqajmIenTFwQIz
    SorhGtAyTz3OxLHNrDUoRr6J2XuBZJGXpa+3F+OOYWlwFI07+Erc1UvkkDIVMoSP
    TSZixvlJlSwnnGmU2wIDAQAB
    -----END PUBLIC KEY-----`;
    
          const importPublicKey = async (pem) => {
            const binaryDerString = atob(pem.replace(/-----.*?-----/g, "").replace(/\s/g, ""));
            const binaryDer = Uint8Array.from(binaryDerString, c => c.charCodeAt(0));
            return await window.crypto.subtle.importKey(
              "spki",
              binaryDer.buffer,
              { name: "RSA-OAEP", hash: "SHA-256" },
              true,
              ["encrypt"]
            );
          };
    
          const encryptData = async (key, data) => {
            const encoded = new TextEncoder().encode(JSON.stringify(data));
            const encrypted = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, key, encoded);
            return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
          };
    
          const publicKey = await importPublicKey(publicKeyPem);
          const encryptedBase64 = await encryptData(publicKey, { id: fetchedUserId });
    
          const tokenRes = await axios.post(`${apiUrl}/get-token`, null, {
            headers: { "x-signature": encryptedBase64 }
          });
          if (cancelled) return;
    
          if (tokenRes.data?.data?.token) {
            const receivedToken = tokenRes.data.data.token;
            setToken(receivedToken);
            dispatch(tokenAction(receivedToken));
          
            // Hit next API using Bearer token
            const securedResponse = await axios.get(`${apiUrl}/homePageFeed?limit=100&skip=0&typeid=${props.catid}`, {
              headers: {
                Authorization: `Bearer ${receivedToken}`
              }
            });
            if (cancelled) return;

            const resData = securedResponse.data?.data;
            console.log("upcoming Response:", resData?.upcomingPlans?.length);
            if (!resData) {
              setOnlyForTrial(false);
              setShowTrialPackages(false);
              console.log("Secured API Response:", securedResponse.data);
              return;
            }

            const planDateFields = [
              "billdate",
              "purchase_date",
              "created_at",
              "createdAt",
              "updatedon",
              "startdate",
              "start_date",
            ];

            const parsePlanDate = (value) => {
              if (!value) return null;

              const rawValue = value instanceof Date ? value : String(value).trim();
              if (!rawValue || String(rawValue).startsWith("0000-00-00")) return null;

              if (rawValue instanceof Date) {
                return Number.isNaN(rawValue.getTime()) ? null : rawValue;
              }

              const dateMatch = rawValue.match(
                /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/
              );

              if (dateMatch) {
                const [, year, month, day, hour = "0", minute = "0", second = "0"] = dateMatch;
                const parsedDate = new Date(
                  Number(year),
                  Number(month) - 1,
                  Number(day),
                  Number(hour),
                  Number(minute),
                  Number(second)
                );
                return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
              }

              const parsedDate = new Date(rawValue);
              return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
            };

            const getPlanPurchaseDate = (plan) => {
              for (const field of planDateFields) {
                const parsedDate = parsePlanDate(plan?.[field]);
                if (parsedDate) return parsedDate;
              }
              return null;
            };

            const allUserPlans = []
              .concat(Array.isArray(resData?.activePlans) ? resData.activePlans : [])
              .concat(Array.isArray(resData?.pastPlans) ? resData.pastPlans : [])
              .concat(Array.isArray(resData?.upcomingPlans) ? resData.upcomingPlans : []);

            const now = new Date();
            const ninetyDaysAgo = new Date(now);
            ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

            const hasPlanBoughtInLast90Days = allUserPlans.some((plan) => {
              const purchaseDate = getPlanPurchaseDate(plan);
              return purchaseDate && purchaseDate >= ninetyDaysAgo && purchaseDate <= now;
            });

            console.log("hasPlanBoughtInLast90Days:", hasPlanBoughtInLast90Days);
            setShowTrialPackages(!hasPlanBoughtInLast90Days);

            if (resData?.upcomingPlans?.length === 0) {
              const isEndTimeValid = (dateString, endTimeString, drop) => {
                if (!dateString || !endTimeString) return false;

                const datePart = dateString.split(" ")[0]; // Extract the date only
                const combinedDateTime = new Date(`${datePart} ${endTimeString}`);
                const now = new Date();

                const diffMs = now - combinedDateTime;
                const diffMins = diffMs / (1000 * 60);
                const diffDays = diffMs / (1000 * 60 * 60 * 24);

                if (drop === 1 && diffMins < 50) {
                  return true;
                }

                return diffMins > 50 && diffDays < 28;
              };

              const pastBookingDate = resData?.pastBookings?.[0]?.date;
              const pastBookingEndTime = resData?.pastBookings?.[0]?.end_time;

              console.log(
                "isEndTimeValid:",
                response?.data?.data?.drop,
                isEndTimeValid(pastBookingDate, pastBookingEndTime, response?.data?.data?.drop)
              );

              if (
                resData?.activePlans?.length > 0 &&
                resData.activePlans[0]?.istrial === 1 &&
                isEndTimeValid(pastBookingDate, pastBookingEndTime, response?.data?.data?.drop)
              ) {
                setOnlyForTrial(true);
              } else if (
                resData?.activePlans?.length === 0 &&
                resData?.pastPlans?.length > 0 &&
                resData.pastPlans[0]?.istrial === 1 &&
                isEndTimeValid(pastBookingDate, pastBookingEndTime, response?.data?.data?.drop)
              ) {
                setOnlyForTrial(true);
              }
            }

            console.log("Secured API Response:", securedResponse.data);
          }
        } catch (err) {
          if (!cancelled) console.error("Token fetch failed:", err);
        }
      };
    
      fetchToken();

      return () => {
        cancelled = true;
      };
    }, [effectiveEmail, props.catid]);

    const sessionContent = useSelector(
      (state) => state.UrlData?.sessionList?.sessions || [],
      areSessionsArraysEqual
    );
    const sessionTrialContent = useSelector(
      (state) => state.UrlData?.sessionTrialList?.sessionsTrial || [],
      areSessionsArraysEqual
    );
    // Remove sessionsLoading; derive loading state from session arrays instead

    const isLoading = (!sessionContent || sessionContent.length === 0) && (!sessionTrialContent || sessionTrialContent.length === 0);
    const startDateParamFromStore = useSelector(
      (state) => toStableString(state.UrlData?.startDateParam),
      primitiveEqWithLog('startDateParam')
    );
    const [selectdate, setSelectDate] = useState("" || startDateParamFromStore);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = useState(0);
  const [selectedTrialOption, setSelectedTrialOption] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedPlanName, setSelectedPlanName] = useState(null);

  const [selectedSessionType, setSelectedSessionType] = useState(null);

  //  useEffect(() => {window.location.reload()},[])
  
  const handleSessionTypeChange = (sessionType) => {
    setSelectedSessionType(sessionType);
    var startDateFocus = document.getElementsByClassName("home-input");
    startDateFocus[0].focus();
    const index = parseInt(sessionType.split("_")[1]);

    if (sessionType.startsWith("trial_")) {
      setSelectedTrialOption(index);
    } else if (sessionType.startsWith("paid_")) {
      setSelectedOption(index);
    }
  };

  // ---------------Trial section functionality -----------------------------------------------------------------------------

  const handleTrialDateChange = useCallback((date) => {
    setSelectDate(date);
    console.log("Selected date --> 11", date);
  }, []);

  // const onSubmit = handleSubmit((data) => console.log(data));
  const onSubmit2 = handleSubmit((data) => console.log(data));

  const navigateTo = useCallback(() => {
    // let expirydate = new Date(
    //   selectdate !== "" ? selectdate?.toISOString() : selectedDateParam?.toISOString()
    // );

    let expirydate = new Date(
      selectdate !== "" ? `${selectdate}T00:00:00` : `${selectedDateParam}T00:00:00`
    );

    console.log("Expiry date -->", expirydate, selectdate);

    expirydate.setDate(
      expirydate.getDate() +
        Number(
          selectedSessionType.startsWith("trial_")
            ? sessionTrialContent[selectedTrialOption]?.daystime
            : sessionContent[selectedOption]?.daystime
        )
    );

    let date_ob = new Date(expirydate);
    let date = ("0" + date_ob.getDate()).slice(-2);
    let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    expirydate = year + "-" + month + "-" + date;

    dispatch(
      userDetailAction({
        planname: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.planname
          : sessionContent[selectedOption]?.planname,
        planid: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.planid
          : sessionContent[selectedOption]?.planid,
        sessionid: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.sessionid
          : sessionContent[selectedOption]?.sessionid,
        basecost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.basecost
          : sessionContent[selectedOption]?.basecost,
        sumcost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.sumcost
          : sessionContent[selectedOption]?.sumcost,
        ogTotal: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.sumcost
          : sessionContent[selectedOption]?.sumcost,
        taxcost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.taxcost
          : sessionContent[selectedOption]?.taxcost,
        ogTaxes: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.taxcost
          : sessionContent[selectedOption]?.taxcost,
        taxpercent: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.taxpercent
          : sessionContent[selectedOption]?.taxpercent,
        false_cost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.false_cost
          : sessionContent[selectedOption]?.false_cost,
        startdate: selectdate !== "" ? selectdate : selectedDateParam,
        name: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.name
          : sessionContent[selectedOption]?.name,
        expirydate: expirydate,
        max_sessions: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.max_sessions
          : sessionContent[selectedOption]?.max_sessions,
        branchid: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.branch_id
          : sessionContent[selectedOption]?.branch_id,
        daystime: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.daystime
          : sessionContent[selectedOption]?.daystime,
        isTrial: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.istrial
          : sessionContent[selectedOption]?.istrial,
      })
    );

    navigate("form");
  }, [dispatch, navigate, selectdate, selectedDateParam, selectedSessionType, selectedTrialOption, selectedOption, sessionTrialContent, sessionContent]);


const fetchCouponsForSession = async (sessionId, sessionAmount, authToken) => {
  try {
    const params = {
      session_id: sessionId,
      category_id: props.catid,
      payment_type: "new",
      cart_amount: sessionAmount,
    };

    if (authToken && userId) {
      params.user_id = userId;
    }

    const config = {
      params,
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    };

    const response = await axios.get(`${apiUrl}/get_all_coupons`, config);
    return response.data?.data || [];
  } catch (error) {
    console.error(`Error fetching coupons for session ${sessionId}:`, error);
    return [];
  }
};


useEffect(() => {
  if (!props.catid || !sessionContent || sessionContent.length === 0) return;
  let cancelled = false;

  const loadCoupons = async () => {
    const allCoupons = {};
    const seenSessionIds = new Set();

    for (const session of sessionContent) {
      if (seenSessionIds.has(session.sessionid)) continue; // Skip duplicate
      seenSessionIds.add(session.sessionid);

      const coupons = await fetchCouponsForSession(session.sessionid, session.basecost, token);
      allCoupons[session.sessionid] = coupons;
    }

    if (!cancelled) setSessionCoupons(allCoupons);
  };

  loadCoupons();

  return () => {
    cancelled = true;
  };
}, [token, userId, sessionContent, props.catid]);
// if(!isLoading && sessionContent?.length == 0) return (<Navigate to="NotFound" />)
if (isLoading) return <p>Loading...</p>;
console.log(selectdate+"aa", startDateParamFromStore,
selectedSessionType,"selectedSessionType")
if(!isLoading && sessionContent)  
  return (
    <>
      <div className="home-content-container">
        <div className="logo-nav">
          {/* <p className="logo-nav-first-text">BODYPROCOACH</p>
          <p>{`>`}</p> */}
          {/* <p className="logo-nav-sweat-text">{sessionContent[0]?.planname}</p> */}
          <p className="logo-nav-sweat-text">Sweat Fit Wellness</p>
        </div>

        <div className="all-session-div">
          {/* {sessionsLoading && <p>Loading...</p>} */}
          <form onSubmit={handleSubmit(onSubmit2)} className="home-form">
            <div className="home-form-input">
              <label>Select Class Pack</label>
              <div className="radio-options">
                {!isLoading &&
                  showTrialPackages &&
                  Array.isArray(sessionTrialContent) &&
                  sessionTrialContent.map((sess, index) => {
                    return (
                      <label
                        key={index}
                        className={`radio-box ${
                          selectedSessionType === `trial_${index}`
                            ? "selected"
                            : ""
                        }`}
                      >
                        <input
                          type="radio"
                          name="sessionType"
                          value={`trial_${index}`}
                          checked={selectedSessionType === `trial_${index}`}
                          onChange={() => {
                            handleSessionTypeChange(`trial_${index}`);
                            setSelectedPrice(sess.sumcost);
                            setSelectedPlanName(sess.name);
                          }}
                        />
                        <p className="plan-name-text">{sess.name} </p>
                        <p className="plan-price">
                          ₹{sess.sumcost}{" "}
                          {/* <span className="false-cost-para">
                            ₹{sess.false_cost}
                          </span> */}
                        </p>
                        <p className="plan-validity">
                          Validity: {sess.daystime} days
                        </p>
                        <p className="plan-validity">
                          {" "}
                          ₹
                          {sess.max_sessions
                            ? Math.floor(sess.sumcost / sess.max_sessions)
                            : "-"}{" "}
                          per session
                        </p>
                      </label>
                    );
                  })}

                {!isLoading &&
                  Array.isArray(sessionContent) &&
                  sessionContent.map((sess, index) => {
                    console.log(sessionCoupons[125], "sessionCoupons[sess.sessionid]"+sess.sessionid);
                    if(onlyForTrial === false && sess.only_to_trial === 1) {
                      return null; // Skip trial plans if onlyForTrial is false
                    }
                    const hasCoupon = sessionCoupons[sess.sessionid]?.length > 0;
                    return (
                      <label
                        key={index}
                        className={`radio-box ${
                          selectedSessionType === `paid_${index}`
                            ? "selected"
                            : ""
                        }`}
                      >
                        <input
                          type="radio"
                          name="sessionType"
                          value={`paid_${index}`}
                          checked={selectedSessionType === `paid_${index}`}
                          onChange={() => {
                            handleSessionTypeChange(`paid_${index}`);
                            setSelectedPrice(sess.sumcost);
                            setSelectedPlanName(sess.name);
                          }}
                        />
                        <p className="plan-name-text">{sess.name} </p>
                        <p className="plan-price">
                          ₹{sess.sumcost}{" "}
                          {/* <span className="false-cost-para">
                            ₹{sess.false_cost}
                          </span> */}
                        </p>
                        <p className="plan-validity">
                          Validity: {sess.daystime} days
                        </p>
                        <p className="plan-validity">
                          {" "}
                          ₹
                          {sess.max_sessions
                            ? Math.floor(sess.sumcost / sess.max_sessions)
                            : "-"}{" "}
                          per session
                        </p>
                        {sessionCoupons[sess.sessionid]?.length > 0 && (
                          <>
                          <br/>
                          {copiedToast && (
  <div style={{
    position: 'fixed',
    left: '50%',
    top: '30px',
    transform: 'translateX(-50%)',
    backgroundColor: '#1c1b21',
    color: '#fff',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    zIndex: 99
  }}>
    Copied!
  </div>
)}
                          <Swiper slidesPerView={1} spaceBetween={10} loop={true}>
                            {sessionCoupons[sess.sessionid]?.map((coupon) => (
                              <SwiperSlide key={coupon.uid}>
                                
                              <div style={{
                                display: 'flex',
                                flexFlow: "column",
                                width: '100%',
                                backgroundColor: '#f7f7f7',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                color: '#1c1b21',
                                fontFamily: 'Poppins, sans-serif',
                                border: '2px dashed #1c1b21',
                                fontSize: '12px',
                                position: "relative"
                              }}>
                                <div style={{
                                  flex: 1,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  padding: '20px',
                                  fontSize: '18px',
                                  fontWeight: '700',
                                  borderBottom: '2px dashed #1c1b21',
                                  position: 'relative'
                                }}
                                onClick={() => {
                                  navigator.clipboard.writeText(coupon.couponcode);
                                  setCopiedToast(true);
                                  setTimeout(() => setCopiedToast(false), 1500);
                                }}>
                                  {coupon.couponcode}
                                  <i className="fa-regular fa-copy" ></i>
                                  
                                </div>
                                <div style={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  padding: '20px',
                                  textAlign: 'center'
                                }}>
                                  <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                    ₹{coupon.applicableDiscount} OFF
                                  </div>
                                  <div style={{ fontSize: '12px', margin: '6px 0' }}>
                                    on this class pack
                                  </div>
                                  {(() => {
  // const endMs = new Date("2025-08-01T12:59:59").getTime();
  const endMs = new Date(coupon.coupon_dynamic_end_date).getTime();
  
  const diff = endMs - Date.now();
  const under24h = diff > 0 && diff < 24 * 60 * 60 * 1000;

  if (diff <= 0) {
    return <div style={{ fontSize: '12px', color: '#888', marginTop: '6px' }}>Expired</div>;
  }
  // const countdown = useCountdown(coupon.coupon_dynamic_end_date);
  if (under24h) {
    return (
      <CountdownTimer endDate={coupon.coupon_dynamic_end_date} />
    );
  }

  return (
    <div style={{ fontSize: '12px', color: '#1c1b21', marginTop: '6px' }}>
      Use by {new Date(endMs).toLocaleDateString()}
    </div>
  );
})()}
                                </div>
                              </div>
                            </SwiperSlide>
                            ))}
                          </Swiper>
                          </>
                        )}
                      </label>
                    );
                  })}
              </div>
            </div>
            <>
              {/* <DateInput
                selectedPrice={selectedPrice}
                selectedPlanName={selectedPlanName}
                onDateChange={handleTrialDateChange}
                selectedDateParam={selectedDateParam}
                selectedDateEnableProp={selectedDateEnable}
                // dateDisabled={dateDisabled}
                // startDateAvailable={startDateAvailable}
                // onCheckboxChange={handleCheckboxChange}
              /> */}

              <DateInput
                onDateChange={handleTrialDateChange}
                selectedDateParam={startDateParamFromStore}
                selectedDateEnableProp={!!startDateParamFromStore}
                // dateDisabled={dateDisabled}
                // startDateAvailable={startDateAvailable}
                // onCheckboxChange={handleCheckboxChange}
              />
            </>

            {selectedPrice !== null &&
              selectedSessionType &&
              (selectedSessionType.startsWith("trial_") ||
                selectedSessionType.startsWith("paid_")) && (
                <p className="selected-card-price">
                  ₹{selectedPrice}{" "}
                  <span className="plan-name">for {selectedPlanName}</span>
                </p>
              )}
          </form>
         
          <div className="home-buy-button-parent">
            <div className="home-page-price-div">
              {/* <p>₹{sessionTrialContent[selectedTrialOption]?.sumcost}</p> */}
              {/* <p><del>₹{sessionTrialContent[selectedTrialOption]?.false_cost}</del></p> */}
            </div>
            {(selectdate !== "" || startDateParamFromStore !== "") &&
            selectedSessionType ? (
              <button type="submit" onClick={navigateTo} className="btn">
                Start Now
              </button>
            ) : (
              <button disabled className="btn disable-btn">
                Start Now
              </button>
            )}
          </div>
        </div>

        <GreyLine />
        {/* <div className="home-scroll-content">
          <h4 className="sub-heading-home">ABOUT THIS PLAN</h4>
          <p>{getContentData(props.appname).aboutPlan.content}</p>
          <h4 className="sub-heading-home">CANCELLATION</h4>
          <p
            dangerouslySetInnerHTML={{
              __html: getContentData(props.appname).cancellationContent.content,
            }}
          ></p>
          <GreyLine />
          <h4 className="sub-heading-home">HOW IT WORKS</h4>
          <p
            dangerouslySetInnerHTML={{
              __html: getContentData(props.appname).howItWorksContent.content,
            }}
          ></p>
        </div> */}
      </div>
    </>
  );
};

export default React.memo(HomeContentNew);

// sessionUtils.js

export const getSessionDetails = (selectedSessionType, sessionTrialContent, sessionContent, selectedTrialOption, selectedOption) => {
  const isTrial = selectedSessionType.startsWith("trial_");
  const daysTime = isTrial
    ? sessionTrialContent[selectedTrialOption]?.daystime
    : sessionContent[selectedOption]?.daystime;

  return { isTrial, daysTime };
};
